export default __webpack_public_path__ + "static/media/flayer4.a8d5756e.jpg";